// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSend24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.5 3.30908C4.57762 3.30908 4.65418 3.32715 4.72361 3.36187L21.1056 11.5529C21.3526 11.6763 21.4527 11.9767 21.3292 12.2237C21.2808 12.3204 21.2023 12.3989 21.1056 12.4473L4.72361 20.6383C4.47662 20.7618 4.17628 20.6616 4.05279 20.4147C4.01807 20.3452 4 20.2687 4 20.191V3.80908C4 3.53294 4.22386 3.30908 4.5 3.30908ZM5.5 13.8001V18.5721L18.645 12.0001L5.5 5.42707V10.2001L10 12.0001L5.5 13.8001Z"
			/>
		</Svg>
	);
});
SvgSend24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSend24;
